import React from 'react';
import { Box, Heading, Divider, Flex, Text } from '@chakra-ui/react';
import { FaHome, FaClipboardList, FaWallet, FaChartLine, FaBell, FaExchangeAlt, FaCog, FaShoppingBasket } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const RestaurantProfile = () => {
 
  return (
    <Box bg="gray.50" p={4}>
      <Box bg="white" p={4} borderRadius="md" mb={4}>
        <Heading color="blue.200">Update Profile</Heading>
      </Box>

      {/* General Info */}
      <Box bg="white" p={4} borderRadius="md" mb={4}>
        <Heading color="blue.200" size="md" mb={2}>
          General Info
        </Heading>
        {/* General Info form */}
      </Box>

      <Divider />

      {/* Social Media */}
      <Box bg="white" p={4} borderRadius="md" mb={4}>
        <Heading color="blue.200" size="md" mb={2}>
          Social Media
        </Heading>
        {/* Social Media form */}
      </Box>

      <Divider />

      {/* Menu */}
      <Box bg="white" p={4} borderRadius="md" mb={4}>
        <Heading color="blue.200" size="md" mb={2}>
          Menu
        </Heading>
        {/* Menu form */}
      </Box>

      <Divider />

      {/* Settings */}
      <Box bg="white" p={4} borderRadius="md" mb={4}>
        <Heading color="blue.200" size="md" mb={2}>
          Settings
        </Heading>
        {/* Settings form */}
      </Box>
            {/* Bottom Navigation for Mobile */}
            <Flex
          bg="blue.200"
          p={2}
          mt={4}
          align="center"
          justify="space-between"
          position="fixed"
          bottom={0}
          mx="auto"
          width="95%"
          display={{ base: 'flex', md: 'none' }} // Hide on larger screens
        >
            <Box textAlign="center" flex="1" p={2}>
              <Link to="restaurant">
                  <Flex alignItems="center" flexDirection="column">
                  <FaHome />
                  <Text color="white" fontSize="xs" mt={1}>
                      Home
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-orders">
                  <Flex alignItems="center" flexDirection="column">
                  <FaClipboardList />
                  <Text color="white" fontSize="xs" mt={1}>
                      Orders
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-market-place">
                  <Flex alignItems="center" flexDirection="column">
                  <FaShoppingBasket />
                  <Text color="white" fontSize="xs" mt={1}>
                      Market
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/restaurant-analytics">
                <Flex alignItems="center" flexDirection="column">
                <FaChartLine />
                <Text color="white" fontSize="xs" mt={1}>
                    Analytics
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-wallet">
                  <Flex alignItems="center" flexDirection="column">
                  <FaWallet />
                  <Text color="white" fontSize="xs" mt={1}>
                      Wallet
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-trades">
                  <Flex alignItems="center" flexDirection="column">
                  <FaExchangeAlt />
                  <Text color="white" fontSize="xs" mt={1}>
                      Trades
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-notifications">
                  <Flex alignItems="center" flexDirection="column">
                  <FaBell />
                  <Text color="white" fontSize="xs" mt={1}>
                      Notifications
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-settings">
                  <Flex alignItems="center" flexDirection="column">
                  <FaCog />
                  <Text color="white" fontSize="xs" mt={1}>
                      Settings
                  </Text>
                  </Flex>
              </Link>
            </Box>   
        </Flex>
        
    </Box>
  );
};

export default RestaurantProfile;
